import { render, staticRenderFns } from "./_vertical.vue?vue&type=template&id=4a5c7c42&"
import script from "./_vertical.vue?vue&type=script&lang=js&"
export * from "./_vertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports